import { DateFormatter } from "@fds/wm-typescript-poc-waap-localization-intl-date-formatter";
import {
  defaultNumberFormatterOptions,
  NumberFormatter,
} from "@fds/wm-typescript-poc-waap-localization-intl-number-formatter";

defaultNumberFormatterOptions.emptyValue = "-";

const numberFormatter = new NumberFormatter(defaultNumberFormatterOptions);
const dateFormatter = new DateFormatter({
  options: {
    date: {
      onlyDate: { year: "numeric", month: "2-digit", day: "2-digit" },
    },
  },
});

export const formatters = {
  dateFormatter,
  numberFormatter,
};
